// @mui
import { useState } from 'react'

import { TableRow, TableCell, IconButton } from '@mui/material'

import TimeWorkSubTableRow from './TimeWorkSubTableRow'

import { Iconify } from 'src/components/base'

interface TimeWorkTableRowProps extends Partial<TableRowProps> {
  row: TimeToWork
  params: ObjectContain | TimeToWorkFiltersDto
}

const TimeWorkTableRow = ({ row, selected, params }: TimeWorkTableRowProps) => {
  const { name, difference, hoursWorked, estimatedHoursWorked, user_id } = row
  const [open, setOpen] = useState(false)

  return (
    <>
      <TableRow
        selected={selected}
        sx={{ cursor: 'pointer' }}
        onClick={() => {
          setOpen(!open)
        }}
      >
        <TableCell
          align="center"
          sx={{
            p: 0,
            width: '50px',

            '&.MuiTableCell-root:first-of-type': {
              paddingLeft: 0
            }
          }}
        >
          <IconButton aria-label="expand row" size="small">
            {open ? (
              <Iconify icon="akar-icons:arrow-up" />
            ) : (
              <Iconify icon="akar-icons:arrow-down" />
            )}
          </IconButton>
        </TableCell>

        <TableCell align="left">{name}</TableCell>

        <TableCell align="left">{hoursWorked}</TableCell>

        <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
          {estimatedHoursWorked}
        </TableCell>

        <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
          {difference}
        </TableCell>
      </TableRow>

      {open && (
        <TableRow>
          <TableCell
            colSpan={6}
            sx={{
              py: 2,
              px: 0,
              verticalAlign: 'top',
              backgroundColor: (theme) =>
                theme.palette.mode === 'dark'
                  ? theme.palette.grey[500_8]
                  : theme.palette.grey[100]
            }}
          >
            <TimeWorkSubTableRow userId={user_id} open={open} params={params} />
          </TableCell>
        </TableRow>
      )}
    </>
  )
}

export default TimeWorkTableRow
